var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SAISelect',_vm._g(_vm._b({attrs:{"value":_vm.value,"options":_vm.searchOptions,"option-label":_vm.optionLabel,"option-value":_vm.optionValue,"disable":_vm.requiredDisable},on:{"filter":_vm.filterFn}},'SAISelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }